import { render, staticRenderFns } from "./formbuilderCompletedMessage.vue?vue&type=template&id=7b0cf6cc&scoped=true"
import script from "./formbuilderCompletedMessage.vue?vue&type=script&lang=js"
export * from "./formbuilderCompletedMessage.vue?vue&type=script&lang=js"
import style0 from "./formbuilderCompletedMessage.vue?vue&type=style&index=0&id=7b0cf6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0cf6cc",
  null
  
)

export default component.exports